import { render, staticRenderFns } from "./SafetyIslandDialog.vue?vue&type=template&id=516fbe73&scoped=true"
import script from "./SafetyIslandDialog.vue?vue&type=script&lang=js"
export * from "./SafetyIslandDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516fbe73",
  null
  
)

export default component.exports